import moment from 'moment'
import { getState, reducers } from 'redux/core'
import { constants, requestWithMock } from 'helpers'


const get = () => {
  const {
    lscSchedules: {
      schedule: {
        newOrder,
      },
      filters: {
        report: {
          date,
          form,
          driversId,
        },
      },
    },
  } = getState()

  const driverIds = []

  newOrder.accessDataList.forEach(({ fixedShiftDataList }) => {
    fixedShiftDataList.forEach(({ driverData }) => {
      if (!driverIds.includes(driverData.id) && driversId.some((lastName) => lastName === driverData.lastName)) {
        driverIds.push(driverData.id)
      }
    })
  })

  const query = {
    report: form === 'Путевые листы' ? 'waybill' : 'dispatcherReport',
    date: moment(date).format('YYYY-MM-DD'),
    driver: driverIds.join('&driver='), // TODO replace to ','
  }

  let url = `${constants.lscSchedules.getReport}?`

  Object.keys(query).forEach((key) => {
    if (query[key]) {
      url = /$\?/.test(url) ? `${url}${key}=${query[key]}` : `${url}&${key}=${query[key]}`
    }
  })

  window.open(url, '_blank')
}


const getGenerationOrderStatus = (date) => {
  const year      = moment(date, 'DD.MM.YYYY').format('YYYY')
  const nextYear  = moment(date, 'DD.MM.YYYY').format('MM') > 9 ? year + 1 : year

  console.log({ date, year, nextYear })

  return requestWithMock(constants.lscSchedules.generateOrderStatus + `?dateMin=${year}-01-01&dateMax=${nextYear}-12-31`)
    .then(({ data }) => reducers.lscSchedules.report.set(data))
}

export default {
  get,
  getGenerationOrderStatus,
}
